import { Achievement } from '@/models';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgAchievedBadgeModal',
})
export default class CmgAchievedBadgeModal extends Vue {
  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get visible(): boolean {
    return this.$appStore.state.ui.modals.achievedBadge.visible;
  }

  get achievement(): Achievement {
    return this.$appStore.state.ui.modals.achievedBadge.args!.achievement;
  }

  get achievementDate(): string {
    return new Date(this.achievement.achievementDate).toLocaleDateString();
  }

  get twitterShareButtonImageUrl(): string {
    return this.$appStore.state.cms.images.buttons.shareTwitter.default;
  }

  onClickShareToTwitter() {
    const twitterAchievementUrl = this.$services.reward.getTwitterAchievementUrl(this.achievement.title, this.$services.config.getTwitterAchievementBaseUrl());
    const tweet = `${this.achievement.shareText}\n ${twitterAchievementUrl}`;
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweet)}`;
    window.open(twitterUrl, '_blank');
  }

  onClose() {
    this.$services.ui.setModalVisibility('achievedBadge', false);
  }
}
